import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBoxSaleGroupCosmeticRequest } from './admin-box-sale-group-cosmetic.request';
import { AdminBoxSaleMissingItemPickStrategy } from '../../enums/admin-box-sale-missing-item-pick-strategy';

@jsonObject
export class AdminBoxSaleGroupRequest {
  @jsonMember(String)
  public readonly id?: Nillable<Guid>;

  @jsonMember(Boolean)
  public readonly isVisibleInQuestionnaire!: boolean;

  @jsonMember(String)
  public readonly missingItemPickStrategy!: AdminBoxSaleMissingItemPickStrategy;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonArrayMember(AdminBoxSaleGroupCosmeticRequest)
  public readonly cosmetics!: AdminBoxSaleGroupCosmeticRequest[];

  public constructor(
    private readonly data: {
      cosmetics: AdminBoxSaleGroupCosmeticRequest[];
      description?: Nillable<string>;
      id?: Nillable<Guid>;
      isVisibleInQuestionnaire: boolean;
      missingItemPickStrategy: AdminBoxSaleMissingItemPickStrategy;
    },
  ) {
    this.id = this.data.id;
    this.isVisibleInQuestionnaire = this.data.isVisibleInQuestionnaire;
    this.missingItemPickStrategy = this.data.missingItemPickStrategy;
    this.description = this.data.description;
    this.cosmetics = this.data.cosmetics;
  }
}
